export const {
  PUBLIC_URL = '',
  REACT_APP_API_BASE_URL = '',
  REACT_APP_API_GESINTEL_BASE_URL = '',
  REACT_APP_BASE_URL = '',
  REACT_APP_CAPACITACION_BASE_URL = '',
  REACT_APP_CAPTCHA_ENABLED = '',
  REACT_APP_CAPTCHA_SITE_KEY = '',
  REACT_APP_CENTROAYUDA_BASE_URL = '',
  REACT_APP_CHILECOMPRA_BASE_URL = '',
  REACT_APP_CONTRACTUAL_BEHAVIOR_BY_REVIEWS_BASE_URL = '',
  REACT_APP_CONTRACT_DETAIL_BASE_URL = '',
  REACT_APP_DJ_ONLY_READ = '',
  REACT_APP_ENABLE_REASON_ANTIUNION_PRACTICES = '',
  REACT_APP_ENVIRONMENT = '',
  REACT_APP_FEATURE_FLAG_ABILITY = '',
  REACT_APP_FEATURE_FLAG_ABILITY_CERTIFICATE_PRIVATE = '',
  REACT_APP_FEATURE_FLAG_ABILITY_CERTIFICATE_PUBLIC = '',
  REACT_APP_FEATURE_FLAG_ABILITY_TAB = '',
  REACT_APP_FEATURE_FLAG_BUSINESS_ACTIVITIES_START_DATE = '',
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR = '',
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_PRIVATE_TAB = '',
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_PUBLIC = '',
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_TAB = '',
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_UTM_VALIDATION = '',
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_V2 = '',
  REACT_APP_FEATURE_FLAG_DOCUMENTS_FRAMEWORK = '',
  REACT_APP_FEATURE_FLAG_FINAL_BENEFICIARY_SECTION = '',
  REACT_APP_FEATURE_FLAG_GENERAL_INFORMATION = '',
  REACT_APP_FEATURE_FLAG_GENERAL_INFORMATION_TAB = '',
  REACT_APP_FEATURE_FLAG_HISTORICAL_SANCTIONS = '',
  REACT_APP_FEATURE_FLAG_LEGAL_DOCUMENTS = '',
  REACT_APP_FEATURE_FLAG_MESSAGE_INFO = '',
  REACT_APP_FEATURE_FLAG_PARTNERSHIP_SECTION = '',
  REACT_APP_FEATURE_FLAG_PAYMENT_WITHOUT_LOGIN = '',
  REACT_APP_FEATURE_FLAG_PO_BIDDING = '',
  REACT_APP_FEATURE_FLAG_REASON_ANTIUNION_PRACTICES = '',
  REACT_APP_FEATURE_FLAG_RECALCULATE_ABILITY_SECTION = '',
  REACT_APP_FEATURE_FLAG_RECAPTCHA_ENABLED = '',
  REACT_APP_FEATURE_FLAG_RELATED_COMPANY_SECTION = '',
  REACT_APP_FEATURE_FLAG_SHOW_MIGRATED_FILES = '',
  REACT_APP_FEATURE_FLAG_SHOW_PRIVATE_UNIQUE_SELLER = '',
  REACT_APP_FEATURE_FLAG_SHOW_PUBLIC_UNIQUE_SELLER = '',
  REACT_APP_FEATURE_FLAG_STAMP = '',
  REACT_APP_FEATURE_FLAG_SUITABILITY_SECTION = '',
  REACT_APP_FEATURE_FLAG_SUMMARY_BUTTON_AFFIDAVIT_PRIVATE = '',
  REACT_APP_FEATURE_FLAG_SUMMARY_SECTION_PUBLIC = '',
  REACT_APP_FEATURE_FLAG_SUMMARY_SELLER_PDF_BUTTON = '',
  REACT_APP_FEATURE_FLAG_TAX_ANNOTATIONS = '',
  REACT_APP_FEATURE_FLAG_TECHNICAL_ACTIVITIES_START_DATE = '',
  REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS = '',
  REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS_TAB = '',
  REACT_APP_FEATURE_FLAG_USER_INFO = '',
  REACT_APP_FEATURE_FLAG_WORK_REGISTER = '',
  REACT_APP_FEATURE_LINK_TO_OPEN_CONTRACT_SELLER = '',
  REACT_APP_FEATURE_LINK_TO_OPEN_DATA_INFORMATION = '',
  REACT_APP_GOOGLE_ANALYTICS_KEY = '',
  REACT_APP_GOOGLE_TASK_MANAGER_ID = '',
  REACT_APP_HOTJAR_ID = '',
  REACT_APP_HOTJAR_SNIPPET_VERSION = '',
  REACT_APP_MERCADO_PUBLICO_BASE_URL = '',
  REACT_APP_MINVU_BASE_URL = '',
  REACT_APP_MINVU_URL = '',
  REACT_APP_MOP_URL = '',
  REACT_APP_OPEN_DATA_BASE_URL = '',
  REACT_APP_OPEN_DATA_CONTRACTS_SELLER = '',
  REACT_APP_OPEN_DATA_INFORMATION_URL = '',
  REACT_APP_PUBLIC_TAB_FLAG_GENERAL_INFORMATION = '',
  REACT_APP_REGISTRARME_URL = '',
  REACT_APP_REVIEWED_CONTRACTS_BASE_URL = '',
  REACT_APP_SANCTION_LEARN_MORE_URL = '',
  REACT_APP_SANCTION_LEARN_SCORE_URL = '',
  REACT_APP_TEMPORARY_UNIONS_BASE_URL = '',
  REACT_APP_MOP_BASE_URL = ''
} = process.env

export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod' && process.env.REACT_APP_ENVIRONMENT !== 'test'
